module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_photowedding_03@2x-175f55f70d05acd822dad588b6d00bd9.webp";